export default {
    "code[class*=\"language-\"]": {
      "color": "#f8f8f2",
      "background": "none",
      "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      "textAlign": "left",
      "whiteSpace": "pre",
      "wordSpacing": "normal",
      "wordBreak": "normal",
      "wordWrap": "normal",
      "lineHeight": "1.5",
      "MozTabSize": "4",
      "OTabSize": "4",
      "tabSize": "4",
      "WebkitHyphens": "none",
      "MozHyphens": "none",
      "msHyphens": "none",
      "hyphens": "none"
    },
    "pre[class*=\"language-\"]": {
      "color": "#f8f8f2",
      "background": "#2b2b2b",
      "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      "textAlign": "left",
      "whiteSpace": "pre",
      "wordSpacing": "normal",
      "wordBreak": "normal",
      "wordWrap": "normal",
      "lineHeight": "1.5",
      "MozTabSize": "4",
      "OTabSize": "4",
      "tabSize": "4",
      "WebkitHyphens": "none",
      "MozHyphens": "none",
      "msHyphens": "none",
      "hyphens": "none",
      "padding": "1em",
      "margin": "0.5em 0",
      "overflow": "auto",
      "borderRadius": "0.3em"
    },
    ":not(pre) > code[class*=\"language-\"]": {
      "background": "#2b2b2b",
      "padding": "0.1em",
      "borderRadius": "0.3em",
      "whiteSpace": "normal"
    },
    "comment": {
      "color": "rgb(150,150,150)"
    },
    "prolog": {
      "color": "rgb(150,150,150)"
    },
    "doctype": {
      "color": "rgb(150,150,150)"
    },
    "cdata": {
      "color": "rgb(150,150,150)"
    },
    "punctuation": {
      "color": "rgb(181, 241, 9)"
    },
    "property": {
      "color": "#ffa07a"
    },
    "tag": {
      "color": "#ffa07a"
    },
    "constant": {
      "color": "#ffa07a"
    },
    "symbol": {
      "color": "#ffa07a"
    },
    "deleted": {
      "color": "#ffa07a"
    },
    "boolean": {
      "color": "rgba( 174, 129, 255, 255)"
    },
    "number": {
      "color": "rgba( 174, 129, 255, 255)"
    },
    "selector": {
      "color": "rgb(181, 241, 9)"
    },
    "attr-name": {
      "color": "rgb(181, 241, 9)"
    },
    "string": {
      "color": "rgb(181, 241, 9)"
    },
    "char": {
      "color": "rgb(181, 241, 9)"
    },
    "builtin": {
      "color": "rgb(181, 241, 9)"
    },
    "inserted": {
      "color": "rgb(181, 241, 9)"
    },
    "operator": {
      "color": "rgb( 253, 134, 30)"
    },
    "entity": {
      "color": "rgb( 253, 134, 30)",
      "cursor": "help"
    },
    "url": {
      "color": "rgb( 253, 134, 30)"
    },
    ".language-css .token.string": {
      "color": "rgb( 253, 134, 30)"
    },
    ".style .token.string": {
      "color": "rgb( 253, 134, 30)"
    },
    "variable": {
      "color": "rgb( 253, 134, 30)"
    },
    "atrule": {
      "color": "rgba(43, 144, 175, 255)"
    },
    "attr-value": {
      "color": "rgba(43, 144, 175, 255)"
    },
    "function": {
      "color": "rgba(249, 37, 77, 255)"
    },
    "keyword": {
      "color": "rgb( 253, 134, 30)"
    },
    "regex": {
      "color": "rgba(43, 144, 175, 255)"
    },
    "important": {
      "color": "rgba(43, 144, 175, 255)",
      "fontWeight": "bold"
    },
    "bold": {
      "fontWeight": "bold"
    },
    "italic": {
      "fontStyle": "italic"
    }
  };